var map = {
	"./afb-color.svg": 1849,
	"./afb.svg": 1850,
	"./alb-color.svg": 1851,
	"./alb.svg": 1852,
	"./amb-color.svg": 1853,
	"./amb.svg": 1854,
	"./bimb-color.svg": 1855,
	"./bimb.svg": 1856,
	"./bkr-color.svg": 1857,
	"./bkr.svg": 1858,
	"./bsn-color.svg": 1859,
	"./bsn.svg": 1860,
	"./cenaidjaxxx-color.svg": 1861,
	"./cimb-color.svg": 1862,
	"./cimb.svg": 1863,
	"./citi-color.svg": 1864,
	"./citi.svg": 1865,
	"./default-bank-icon-color.png": 1866,
	"./default-bank-icon.png": 1867,
	"./hlb-color.svg": 1868,
	"./hlb.svg": 1869,
	"./hsbc-color.svg": 1870,
	"./hsbc.svg": 1871,
	"./kwh-color.svg": 1872,
	"./kwh.svg": 1873,
	"./mbb-color.svg": 1874,
	"./mbb.svg": 1875,
	"./ocbc-color.svg": 1876,
	"./ocbc.svg": 1877,
	"./pbb-color.svg": 1878,
	"./pbb.svg": 1879,
	"./rhb-b.svg": 1880,
	"./rhb-color-b.svg": 1881,
	"./rhb-color.svg": 1882,
	"./rhb.svg": 1883,
	"./scb-color.svg": 1884,
	"./scb.svg": 1885,
	"./uob-color.svg": 1886,
	"./uob.svg": 1887
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 379;